<template>
  <TheWorkFormShell :events="cEventsorted">
    <RouterView v-if="isLoaded" @refreshWork="handleRefreshWork" />
    <div v-else class="box flex h-full flex-col shadow-md sm:mx-5">
      <LoadingComponent />
    </div>
  </TheWorkFormShell>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

import moment from 'moment'

import LoadingComponent from '@c/TheLoadingComponent.vue'
import TheWorkFormShell from '@p/works/form/TheWorkFormShell.vue'

/**
 * Loads the work, as Funeral Manager's TheDossierFormEditPage: the frame and
 * the menu show at once, the tab waits for the work matching the route. The
 * page stays mounted when going from one work to another (search, links),
 * so the `id` watcher fetches the new one.
 */
export default {
  name: 'TheWorkFormEditPage',
  components: { LoadingComponent, TheWorkFormShell },
  props: {
    // from the router
    id: { type: String, required: true }
  },
  computed: {
    ...mapGetters({ work: 'work/getWork' }),
    isLoaded() {
      return String(this.work?.id) === String(this.id)
    },
    cEventsorted() {
      if (!this.isLoaded || !this.work?.events) return []
      return [...this.work.events].sort(
        (a, b) =>
          Date.parse(
            moment(a.date_from + ' ' + a.time_from, 'DD/MM/YYYY HH:mm')
          ) -
          Date.parse(
            moment(b.date_from + ' ' + b.time_from, 'DD/MM/YYYY HH:mm')
          )
      )
    }
  },
  watch: {
    id(newValue, oldValue) {
      if (newValue !== oldValue) this.loadWork()
    }
  },
  mounted() {
    this.loadWork()
  },
  methods: {
    ...mapActions({ fetchWorkByID: 'work/fetchWorkByID' }),
    ...mapMutations({ setWork: 'work/setWork' }),
    loadWork() {
      // Do not show the previous work while this one loads.
      if (!this.isLoaded) this.setWork({ deceased: {}, work_items: [] })
      this.fetchWorkByID(this.id)
    },
    handleRefreshWork() {
      this.fetchWorkByID(this.id)
    }
  }
}
</script>
